export default {
  paragraphPaddingBottomEm: '.93em'
}



// WEBPACK FOOTER //
// ./src/Theme.ts